import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {BsModalService, ModalOptions} from 'ngx-bootstrap/modal';
import {Subject, Subscription} from 'rxjs';
import * as _ from 'lodash';
import { ActionBarAction } from 'src/shared/constants/action-bar.action';
import { ActionBarService } from 'src/shared/service/action-bar.service';
import { TabItem } from 'src/shared/model/tab-item';


@Component({
  selector: 'dcu-tab-bar',
  templateUrl: './tab-bar.component.html',
  styleUrls: ['./tab-bar.component.scss']
})
export class TabBarComponent implements OnInit, OnDestroy {

  ngUnsubscribe: Subject<boolean> = new Subject<boolean>();
  subscriptions: Subscription[] = [];

  @Input() tabItems: TabItem[] = [];
  @Input() limitTab = 8;
  @Input() isChange = false;
  @Output() changeTabBar: EventEmitter<any> = new EventEmitter();

  constructor(private router: Router,
              private route: ActivatedRoute,
              private dialogService: BsModalService,
              private csEventService: ActionBarService
  ) {
    // listener
    this.csEventService.changeEmitted.takeUntil(this.ngUnsubscribe).subscribe(value => {
      switch (value) {
        case ActionBarAction.DISABLE:
          this.isChange = false;
          break;
        case ActionBarAction.ENABLE:
          this.isChange = true;
          break;
        default:
          break;
      }
    });
  }

  ngOnInit() {
    // init tab
    const index = this.tabItems
      .findIndex(item => this.router.url.endsWith(item.url as string));
    if (index >= this.limitTab) {
      this.swapItem(index);
    }
    // not emit at first time loading overview page

     const activeTab = this.tabItems.filter((item: any) => this.router.url.endsWith(item.url) && item.isActive === true);
     if(activeTab && activeTab.length > 0){
       this.changeTabBar.emit(activeTab[0]);
     }
  }

  isActive(ele: TabItem | any) {
    if (this.router.url.endsWith(ele.url) && ele.isActive) {
      return true;
    }
    return false;
  }

  checkActiveTab(ele: TabItem | any) {
    if (!this.router.url.endsWith(ele.url)){
      this.changeTabBar.emit(ele);
    }
    if (!ele.isActive) {
      return false;
    }
    this.changeTabBar.emit(ele);
    return true;
  }

  navigateByUrl(ele: TabItem | any) {
    if (!this.checkActiveTab(ele)) {
      return;
    }
    this._redirectUrl(ele);
  }

  private _redirectUrl(ele: TabItem | any) {
    const action = () => {
      this.router.navigate([`${ele.url}`], {relativeTo: this.route}).finally();
    };

    action();
    // if (this.isChange && !this.router.url.endsWith(ele.url as string)) {
    //   this.config.initialState = {
    //     modalData: {
    //       title: CommonConstants.CONFIRM_TITLE_CHANGE_TAB,
    //       notifyMessage: CommonConstants.CONFIRM_CONTENT_CHANGE_TAB,
    //       nameButtonCancel: CommonConstants.DIALOG_CANCEL_BUTTON,
    //       nameButtonAction: CommonConstants.DIALOG_CONFIRM_BUTTON
    //     }
    //   };
    //   const bsModalRef = this.dialogService.show(CsConfirmationDialogComponent, this.config);
    //   bsModalRef.setClass('modal-dialog-centered');
    //   this.subscriptions.push(this.dialogService.onHide.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => {
    //     if (bsModalRef.content.confirmed) {
    //       action();
    //       // emit event change done.
    //       this.csEventService.emitChange(ActionBarAction.DISABLE);
    //       this.changeOverview.emit(true);
    //     } else {
    //       this.changeOverview.emit(false);
    //     }
    //     this.unsubscribe();
    //   }));
    // } else {
    //   if ('overview' !== ele.url){
    //     this.changeOverview.emit(true);
    //   } else {
    //     this.changeOverview.emit(false);
    //   }
    //   action();
    // }
  }

  // change tab
  navigate(item: TabItem | any) {
    if (!this.checkActiveTab(item)) {
      return;
    }

    const index = this.tabItems.indexOf(item);
    this.swapItem(index);

    // redirect by url
    this._redirectUrl(item);
  }

  swapItem(index: any) {
    // swap item in tabItems
    [this.tabItems[this.limitTab - 1], this.tabItems[index]] = [this.tabItems[index], this.tabItems[this.limitTab - 1]];
  }

  unsubscribe() {
    _.forEach(this.subscriptions, (subscription: Subscription) => {
      subscription.unsubscribe();
    });
    this.subscriptions = [];
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
